import i18n from 'i18next';
// import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import moment from "moment"
import 'moment/locale/fr'
import 'moment/locale/es'

import translationFR from "./assets/translations/fr/translation.json"
import translationEN from "./assets/translations/en/translation.json"
import translationES from "./assets/translations/es/translations.json"
import translationDE from "./assets/translations/de/translation.json";

const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
  es: { translation: translationES },
  de: { translation: translationDE },
};

// const availableLanguages = ['fr', 'en'];
const language = navigator.language.split(/[-_]/)[0];
const fallbackLng = [
  language !== "fr" &&
  language !== "en" &&
  language !== "es" &&
  language !== "de"
    ? "en"
    : language,
];

i18n
  // .use(Backend) // load translation using xhr -> see /public/locales
  // .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
      resources,
    fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: false,
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json'
    },
    // whitelist: availableLanguages,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  })
  .then(() => {
    if (i18n.language) moment.locale(i18n.language)
  })




export default i18n;
